export default __webpack_public_path__ + "static/media/content-section_default.04b94dd3.svg";